import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { PracticePlaceService } from 'app/shared/services/practice-place/pratcice-place.service';

export interface DialogData {
  title: string;
  text: string;
  action: string;
  id?: number;
}

@Component({
  selector: 'app-open-dialog-delete-element',
  templateUrl: './open-dialog-delete-element.component.html',
  styleUrls: ['./open-dialog-delete-element.component.scss'],

})
export class OpenDialogDeleteElementComponent implements OnInit {

  isConfirm = false;

  constructor(
    public dialogRef: MatDialogRef<OpenDialogDeleteElementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private offerService: OfferService,
    private practicePlaceService: PracticePlaceService
  ) { }

  ngOnInit(): void {
  }

  confirmAction(): void {

    switch (this.data.action) {
      case 'deleteOffer':
        this.offerService.deleteOffer(this.data.id).subscribe({
          next: () => { this.dialogRef.close(); }
        });
        break;
      case 'deletePracticePlace':
        this.practicePlaceService.deletePracticePlaceByClub(this.data.id).subscribe({
          next: () => { this.dialogRef.close(); }
        });
        break;

      default:
        break;
    }
  }

}
